import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { getProtectedRoute } from 'helpers/routeHelper';
import { connect } from 'react-redux';
import routes from './routes';

export class StockOpnameRouter extends Component {
  render() {
    return (
      <div className={'p-4'}>
        <div>
          {routes.map((r, i) =>
            <Route
              key={i}
              path={`${this.props.match.url}${r.path}`}
              exact={r.exact}
              render={props => getProtectedRoute(r, props)}
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(StockOpnameRouter)
)
